// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const PageSelector: MarkdocTagRegistration = {
  tag: 'page-selector',
  component: 'PageSelector',
  selfClosing: true,
  attributes: {},
};
